import { render, staticRenderFns } from "./AdminTicketActions.vue?vue&type=template&id=70a00cb2&"
import script from "./AdminTicketActions.vue?vue&type=script&lang=ts&"
export * from "./AdminTicketActions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports